import script from "./NewProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./NewProjectModal.vue?vue&type=style&index=0&id=a47bba3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47bba3e"]])

export default __exports__